import { useLocation, useNavigate } from "react-router-dom";
import TermsText from "../../components/appTerms/termsText";
import { SolidColorButton } from "../../components/buttons";
import { LeftArrowIcon } from "../../components/icons";
import "./infoPage.scss";

const InfoPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    const params = new URLSearchParams(location.search);
    const fromParam = params.get("from");

    if (fromParam) {
      const decoded = decodeURIComponent(fromParam);
      navigate(decoded, { replace: true });
      return;
    }

    // fallback if someone deep-linked into /information directly
    navigate(-1);
  };

  return (
    <div id="infoTop">
      <SolidColorButton
        solidColorBtnImage={
          <LeftArrowIcon
            height="15px"
            width="15px"
            fillColor="#964b00"
            strokeWidth="4"
            strokeColor="#964b00"
          />
        }
        className="gold-btn"
        solidColorBtnText="Back"
        solidColorBtnFontWeight="800"
        solidColorBtnFontFamily="helvetica"
        solidColorBtnTextFontSize=".75rem"
        solidColorBtnFontColor="#964b00"
        solidColorBtnWidth="100px"
        solidColorBtnBoxShadow="0 4px 3px 1px #000000bb, 0 6px 8px #000000bb, 0 -4px 4px #000000bb, 0 -6px 4px #000000bb, inset 0 0 3px 0 #000000bb"
        onClick={handleBack}
      />

      <TermsText />
    </div>
  );
};

export default InfoPage;